import styles from './kebap-menu.module.scss';
import { Icon, IconTypes } from '../../atoms';
import classNames from 'classnames';

export type KebapMenuItemProps<T> = {
  key: T;
  children?: React.ReactNode;
  icon?: IconTypes;
  onClick: (key: T) => void
  isActive?: boolean;
}

export const KebapMenuItem = <T extends string | number = string,>({ children, icon, onClick, key, isActive = false }: KebapMenuItemProps<T>) => {
  return (
    <div className={classNames({
      [styles.kebapMenuItem]: true,
      [styles.isActive]: isActive,
    })} onClick={() => onClick(key)} key={key}>
      {icon && (
        <span className={styles.kebapMenuItemIcon}>
          <Icon icon={icon} size={'16px'} />
        </span>
      )}
      <span className={styles.kebapMenuItemText}>{children}</span>
    </div>
  );
};
